<template>
  <jz-container class="course-list-item">
    <img :src="course.image" />
    <div class="course-title">{{ course.title }}</div>
    <span class="exercise-count">
      <abbr :title="course.numExercises"
        >{{ course.numExercises }} {{ "course.details.exercises" | __ }}</abbr
      >
    </span>
    <course-tags :levels="course.levels" :categories="course.categories" />
  </jz-container>
</template>

<script>
import CourseTags from "@tt-app/components/course/CourseTags.vue";

export default {
  components: {
    CourseTags
  },
  props: {
    course: { type: Object, required: true }
  }
};
</script>

<style lang="scss">
.course-list-item {
  align-items: center;
  display: grid;
  gap: ($gutter / 2);
  grid-template-areas: "image title" "image exercise-count" "image tags";
  grid-template-columns: 80px auto;
  padding: ($gutter * 0.75) $gutter;

  img {
    grid-area: image;
    height: 60px;
    object-fit: contain;
    width: 80px;
  }

  .course-title {
    color: var(--color-dark);
    display: -webkit-box;
    font-size: $font-size-sm;
    font-weight: bold;
    grid-area: title;
    min-height: 38px;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .exercise-count {
    color: var(--color-secondary);
    font-size: $font-size-xs;
    font-weight: bold;
    grid-area: exercise-count;
    height: 17px;

    @include ellipsis;

    abbr {
      text-decoration: none;
    }
  }
}

@include responsive(tablet) {
  .course-list-item {
    grid-template-areas: "image title title" "image exercise-count tags";
    grid-template-columns: 80px 1fr 1fr;

    .course-tags-container {
      justify-items: end;

      .course-tags {
        justify-content: flex-end;
      }
    }
  }
}

@include responsive(desktop) {
}
</style>
